export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20fashion%20boutique%20retail%20display%20with%20neatly%20arranged%20products%20on%20white%20lacquer%20geometric%20shelving%2C%20soft%20peach%20and%20beige%20toned%20apparel%20accessories%20including%20scarves%20and%20handbags%2C%20bright%20airy%20showroom%20with%20large%20windows%2C%20clean%20contemporary%20commercial%20interior%20design%2C%20aspirational%20lifestyle%20retail%20photography%20with%20polished%20professional%20finish&width=1600&height=800&seq=cta-bg-v4&orientation=landscape&nocache=true"
          alt="Premium fashion and lifestyle products organized for shopping"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50 via-background-50/85 to-background-50"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
          Ready to Organize Your Basetao Shopping Workflow?
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-lg mx-auto">
          Start managing your orders, shipping costs, and warehouse data with powerful spreadsheet tools designed for smarter international shopping.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all duration-200 whitespace-nowrap"
          >
            Explore Basetao Spreadsheet Tools
            <div className="w-4 h-4 inline-flex items-center justify-center ml-2">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-background-50 bg-accent-500 hover:bg-accent-600 rounded-lg transition-all duration-200 whitespace-nowrap"
          >
            Buy It Now
            <div className="w-4 h-4 inline-flex items-center justify-center ml-2">
              <i className="ri-shopping-cart-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}